import dispatcher from "../dispatcher"
import * as api from "../api"
import strings from "../localization/strings"
import { ETimeoffStatus, ITimeoffRequestDocument } from "../models"
import AppStateStore from "../stores/AppStateStore"

export function setStateFilter(_data) {
	dispatcher.dispatch({ type: "UPDATE_LEAVE_TRACKING_STATE_FILTER", data: _data })
}

export function setDateFilter(_data) {
	dispatcher.dispatch({ type: "UPDATE_LEAVE_TRACKING_DATE_FILTER", data: _data })
}

export function setOffset(_data) {
	dispatcher.dispatch({ type: "UPDATE_LEAVE_TRACKING_OFFSET", data: _data })
}

export function setLimit(_data) {
	dispatcher.dispatch({ type: "UPDATE_LEAVE_TRACKING_LIMIT", data: _data })
}

export function setSearchText(_data) {
	dispatcher.dispatch({ type: "UPDATE_LEAVE_TRACKING_SEARCH", data: _data })
}

export function initLeaveTrackingOffsetSearch() {
	dispatcher.dispatch({ type: "INIT_LEAVE_TRACKING_OFFSET_SEARCH" })
}

export function handleUpdateStatus(status: ETimeoffStatus, selectedLeaveRequests: ITimeoffRequestDocument[], successCb) {
	AppStateStore.setProgressSnackbarContent("loading")
	api.updateLeaveRequestsStatus(selectedLeaveRequests.map(item => item.Id), status).then(res => {
		switch (res.data) {
			case "Cannot_approve_the_approved_or_denied_leave_request":
				AppStateStore.setProgressSnackbarContent(strings.Cannot_approve_the_approved_or_denied_leave_request)
				break
			case "Cannot_deny_the_denied_leave_request":
				AppStateStore.setProgressSnackbarContent(strings.Cannot_deny_the_denied_leave_request)
				break
			case "Cannot_approve_leave_request_for_locked_period":
				AppStateStore.setProgressSnackbarContent(strings.Cannot_approve_leave_request_for_locked_period)
				break
			case "Cannot_deny_leave_request_for_locked_period":
				AppStateStore.setProgressSnackbarContent(strings.Cannot_deny_leave_request_for_locked_period)
				break
			case "Leave_request_approved_successfully":
				AppStateStore.setProgressSnackbarContent(strings.Leave_request_approved_successfully)
				break
			case "Leave_request_denied_successfully":
				AppStateStore.setProgressSnackbarContent(strings.Leave_request_denied_successfully)
				break
			case "Cannot_approve_leave_request_because_paytype_invalid":
				AppStateStore.setProgressSnackbarContent(strings.Cannot_approve_leave_request_because_paytype_invalid)
				break
			case "Employee_cannot_approve_or_deny_leave_request":
				AppStateStore.setProgressSnackbarContent(strings.You_have_not_permission)
				break
		}
		if (res.data === "Leave_request_approved_successfully" || res.data === "Leave_request_denied_successfully") {
			if (successCb && typeof successCb === "function")
				successCb()
		}
	})
}
